export { PhoneOutgoing as default } from './PhoneOutgoing';
